<template>
  <div class="TimeLine" v-if="visible">
    <div class="TimeLine__events">
      <div class="TimeLine__fill" :style="barStyles"></div>
      <TimeLineEvent 
        v-for="event in timelineData" 
        :key="event.date" 
        :date="event.date"
        :label="event.label"
        :title="event.title"
        :start="start" 
        :end="end" 
        @activated="activated" />
    </div>
  </div>
</template>

<script>

import TimeLineEvent from './TimeLineEvent';
import dynamicSort from '@/helpers/dynamicSort';

export default {
  name: 'TimeLine',
  components: {
    TimeLineEvent
  },
  data() {
    return {
      offset: 0
    }
  },
  computed: {
    timelineData() {
      let slug = this.$store.getters.getActiveProjectSlug;
      if (slug === null) {
        return [] // nada
      }

      let project = this.$store.getters.getProjectBySlug({
        slug
      });

      if (!project) {
        return [];
      }
      
      let headers = this.$store.getters.getSegmentHeadersByProjectId({
        id: project.id 
      })
      .filter((header) => {
        return header.timeline && header.date !== '';
      })
      .map((header) => {
        return {
          date: header.date,
          label: header.label || '',
          title: header.header || ''
        }
      })
      .sort(dynamicSort('date'));
      
      return headers;
    },
    timelineDistance() {
      let first = this.timelineData[0];
      let last = this.timelineData[this.timelineData.length - 1];

      return [
        first, last
      ];
    },
    start() {
      return this.timelineDistance[0].date;
    },
    end() {
      return this.timelineDistance[1].date;
    },
    barStyles() {
      return {
        'transform' : `scaleX(${this.offset})`
      }
    },
    visible() {
      return this.timelineData.length !== 0;
    }
  },
  methods: {
    activated({offset}) {
      this.offset = (parseFloat(offset) / 100);
    }
  }
}
</script>

<style lang="scss">

.TimeLine {
  position: relative;
  padding: 64px 0; // 40px 14px
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  // max-width: 1920px;
  background: $gray_light;
  border-top: 1px solid $gray_mid;
  font-family: $font_body;

  &__events {
    position: relative;
    // width: 96%;
    width: 94%;
    height: 2px;
    overflow: visible;
    background: rgba(0, 0, 0, 0.15); // !important;rgba(77,77,77,1);
    top: -1px;
    // left: 2%;
    // left: 0;
    margin: auto;
    
    &:before, &:after {
      content: '';
      position: absolute;
      top: 0;
      height: 100%;
      width: 20px;
      z-index: 2;
    }

    &:before {
      background-image: linear-gradient(to right,#f8f8f8,rgba(248,248,248,0))
    }
    &:after {
      right: 0;
      background-image: linear-gradient(to left,#f8f8f8,rgba(248,248,248,0));
    }
  }

  &__fill {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: $color_primary; // #2da798; // #7b9d6f;
    width: 100%;
    transform: scaleX(0);
    transition: transform .3s ease-in-out;
    transform-origin: left center;
  }
}

</style>
